type IconProps = React.SVGProps<SVGSVGElement>;

const ClockFilled: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.99991 11.9949C2.01414 6.46438 6.50429 1.98808 12.0249 2.00002C17.516 2.01197 22.0187 6.53038 21.9993 12.008C21.9794 17.58 17.4802 22.0256 11.8861 22C6.45763 21.975 1.98569 17.4498 1.99991 11.9949ZM12.9047 9.00122H12.9035C12.9035 8.18481 12.9092 7.3684 12.9012 6.55256C12.8961 6.02631 12.5103 5.6457 12.0028 5.64399C11.4941 5.64228 11.0986 6.02119 11.0969 6.54403C11.0906 8.36118 11.0946 10.1783 11.094 11.9955C11.094 12.2418 11.1748 12.4569 11.3472 12.6304C12.2639 13.5509 13.1806 14.4714 14.1036 15.3851C14.35 15.6292 14.6607 15.6918 14.9913 15.5911C15.6582 15.3874 15.8499 14.5773 15.3475 14.0664C14.5907 13.2977 13.8253 12.5371 13.0589 11.7776C12.9502 11.67 12.8995 11.5642 12.9007 11.4072C12.9086 10.605 12.9047 9.80283 12.9047 9.00122Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ClockFilled;
